import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { AppStatusBarService } from '../../core/services/app-status-bar.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-status-footer',
  standalone: false,
  templateUrl: './app-status-footer.component.html',
  styleUrl: './app-status-footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppStatusFooterComponent implements OnInit, OnDestroy {
  readonly motto = 'Simplicity is the ultimate sophistication';
  readonly appVersion = environment.appVersion;

  username = '';
  locationLabel = '';
  idleSeconds = 0;
  chargeBatch = '';
  paymentBatch = '';
  isEmergencyLogin = false;

  private subs = new Subscription();

  constructor(
    private authService: AuthService,
    private statusBar: AppStatusBarService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.chargeBatch = this.statusBar.chargeBatch;
    this.paymentBatch = this.statusBar.paymentBatch;
    this.idleSeconds = this.statusBar.idleSeconds;
    this.refreshUser();
    this.refreshLocationLabel();

    this.subs.add(
      this.authService.currentUser$.subscribe(() => {
        this.refreshUser();
        this.refreshLocationLabel();
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.statusBar.idleSeconds$.subscribe((seconds) => {
        this.idleSeconds = seconds;
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.statusBar.chargeBatch$.subscribe((batch) => {
        this.chargeBatch = batch;
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.statusBar.paymentBatch$.subscribe((batch) => {
        this.paymentBatch = batch;
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.statusBar.dbLocation$.subscribe(() => {
        this.refreshLocationLabel();
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private refreshUser(): void {
    const user = this.authService.getCurrentUser();
    this.username = user?.username?.trim() || '';
    this.isEmergencyLogin = user?.isEmergency === true;
  }

  private refreshLocationLabel(): void {
    const user = this.authService.getCurrentUser();
    this.locationLabel = (user?.dbLocation || this.statusBar.dbLocation || '').trim();
  }
}
